export default __webpack_public_path__ + "static/media/outward_icon.fabdd6c7.svg";